import React from "react";
import styled from "styled-components";
import emblem from "../assets/internal/emblem.svg";
import { PlainLink } from "./navigation/NavLink";
import { useMediaQuery } from "react-responsive/src";
import { breakpoint } from "../utils/responsive";

const Icon = ({ children, style, alt, onClick }) => (
  <img src={children} style={style} alt={alt || "icon"} onClick={onClick} />
);

export const FacebookIcon = props => (
  <PlainLink
    href={props.href || "https://www.facebook.com"}
    target="_blank"
    rel="noopener"
  >
    <svg
      width="14"
      height="30"
      viewBox="0 0 14 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5336 10.0374H9.08357V7.03044C9.08357 5.90117 9.81001 5.63789 10.3217 5.63789C10.8321 5.63789 13.462 5.63789 13.462 5.63789V0.673398L9.13712 0.656006C4.33611 0.656006 3.24354 4.35869 3.24354 6.72818V10.0374H0.467007V15.1531H3.24354C3.24354 21.7182 3.24354 29.6285 3.24354 29.6285H9.08357C9.08357 29.6285 9.08357 21.6403 9.08357 15.1531H13.0243L13.5336 10.0374Z"
        fill="#CDAD77"
      />
    </svg>
  </PlainLink>
);
export const InstagramIcon = props => (
  <PlainLink
    href={props.href || "https://www.instagram.com"}
    target="_blank"
    rel="noopener"
  >
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0393 2.90567C20.2816 2.90567 20.8046 2.90567 22.4899 3.0219C24.059 3.08001 24.8725 3.37058 25.4537 3.54492C26.2092 3.83549 26.7322 4.18417 27.3133 4.7653C27.8945 5.34644 28.2431 5.86946 28.5337 6.62493C28.7662 7.20607 28.9986 8.01965 29.0567 9.58872C29.1148 11.274 29.1729 11.797 29.1729 16.0393C29.1729 20.2816 29.1729 20.8046 29.0567 22.4899C28.9986 24.059 28.708 24.8726 28.5337 25.4537C28.2431 26.2092 27.8945 26.7322 27.3133 27.3133C26.7322 27.8944 26.2092 28.2431 25.4537 28.5337C24.8725 28.7661 24.059 28.9986 22.4899 29.0567C20.8046 29.1148 20.2816 29.1729 16.0393 29.1729C11.797 29.1729 11.274 29.1729 9.58872 29.0567C8.01966 28.9986 7.20607 28.708 6.62493 28.5337C5.86946 28.2431 5.34644 27.8944 4.7653 27.3133C4.18417 26.7322 3.83549 26.2092 3.54492 25.4537C3.31247 24.8726 3.08001 24.059 3.0219 22.4899C2.96379 20.8046 2.90567 20.2816 2.90567 16.0393C2.90567 11.797 2.90567 11.274 3.0219 9.58872C3.08001 8.01965 3.37058 7.20607 3.54492 6.62493C3.83549 5.86946 4.18417 5.34644 4.7653 4.7653C5.34644 4.18417 5.86946 3.83549 6.62493 3.54492C7.20607 3.31247 8.01966 3.08001 9.58872 3.0219C11.274 2.90567 11.797 2.90567 16.0393 2.90567ZM16.0393 0C11.6808 0 11.1578 4.41638e-07 9.47249 0.116227C7.7872 0.174341 6.62493 0.464907 5.57889 0.871701C4.53285 1.2785 3.66115 1.80152 2.73133 2.73133C1.85963 3.60303 1.2785 4.53285 0.871702 5.57889C0.464907 6.56682 0.232454 7.72909 0.116227 9.47249C0.0581139 11.1578 0 11.7389 0 16.0393C0 20.3978 4.41638e-07 20.9208 0.116227 22.6061C0.174341 24.2914 0.464907 25.4537 0.871702 26.4997C1.2785 27.5458 1.80152 28.4175 2.73133 29.3473C3.60303 30.219 4.53285 30.8001 5.57889 31.2069C6.56682 31.6137 7.72909 31.8462 9.47249 31.9624C11.1578 32.0205 11.7389 32.0786 16.0393 32.0786C20.3397 32.0786 20.9208 32.0786 22.6061 31.9624C24.2914 31.9043 25.4537 31.6137 26.4997 31.2069C27.5458 30.8001 28.4175 30.2771 29.3473 29.3473C30.219 28.4756 30.8001 27.5458 31.2069 26.4997C31.6137 25.5118 31.8462 24.3495 31.9624 22.6061C32.0205 20.9208 32.0786 20.3397 32.0786 16.0393C32.0786 11.7389 32.0786 11.1578 31.9624 9.47249C31.9043 7.7872 31.6137 6.62493 31.2069 5.57889C30.8001 4.53285 30.2771 3.66115 29.3473 2.73133C28.4756 1.85963 27.5458 1.2785 26.4997 0.871701C25.5118 0.464907 24.3495 0.232454 22.6061 0.116227C20.9208 4.41638e-07 20.3978 0 16.0393 0Z"
        fill="#CDAD77"
      />
      <path
        d="M16.0393 7.78711C11.5065 7.78711 7.84531 11.4483 7.84531 15.9811C7.84531 20.514 11.5065 24.1751 16.0393 24.1751C20.5722 24.1751 24.2333 20.514 24.2333 15.9811C24.2333 11.4483 20.5722 7.78711 16.0393 7.78711ZM16.0393 21.3275C13.0755 21.3275 10.6929 18.9449 10.6929 15.9811C10.6929 13.0173 13.0755 10.6347 16.0393 10.6347C19.0031 10.6347 21.3857 13.0173 21.3857 15.9811C21.3857 18.9449 19.0031 21.3275 16.0393 21.3275Z"
        fill="#CDAD77"
      />
      <path
        d="M24.582 9.35624C25.6411 9.35624 26.4997 8.49764 26.4997 7.43849C26.4997 6.37935 25.6411 5.52075 24.582 5.52075C23.5228 5.52075 22.6642 6.37935 22.6642 7.43849C22.6642 8.49764 23.5228 9.35624 24.582 9.35624Z"
        fill="#CDAD77"
      />
    </svg>
  </PlainLink>
);

export const TwitterIcon = props => (
  <PlainLink
    href={props.href || "https://www.twitter.com"}
    target="_blank"
    rel="noopener"
  >
    <svg
      width="34"
      height="28"
      viewBox="0 0 34 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34 3.31481C32.7491 3.87756 31.4047 4.25656 29.9937 4.4274C31.4344 3.55312 32.5408 2.16776 33.0607 0.516817C31.7135 1.3265 30.2203 1.91509 28.6308 2.23236C27.3601 0.858491 25.5453 0 23.5393 0C19.0357 0 15.7264 4.258 16.7436 8.67822C10.948 8.38392 5.80833 5.57014 2.36725 1.29348C0.53975 4.47047 1.4195 8.62654 4.52483 10.7311C3.383 10.6938 2.30633 10.3765 1.36708 9.8468C1.29058 13.1214 3.60683 16.185 6.9615 16.8669C5.97975 17.1368 4.9045 17.2 3.81083 16.9875C4.69767 19.7955 7.27317 21.8384 10.3275 21.8958C7.395 24.2258 3.70033 25.2666 0 24.8244C3.08692 26.83 6.75467 28 10.693 28C23.6442 28 30.9612 16.9157 30.5192 6.97416C31.8821 5.97641 33.065 4.73175 34 3.31481Z"
        fill="#CDAD77"
      />
    </svg>
  </PlainLink>
);

export const YouTubeIcon = props => (
  <PlainLink href={props.href} target="_blank" rel="noopener">
    <svg height="34" viewBox="0 -43 512 512" width="34">
      <path
        fill="#CDAD77"
        d="m450.644531 23.011719-28.628906-5.921875c-110.164063-22.785156-221.867187-22.785156-332.03125 0l-28.628906 5.921875c-35.550781 7.34375-61.355469 39.03125-61.355469 75.339843v229.929688c0 36.308594 25.804688 67.992188 61.355469 75.339844l28.628906 5.921875c55.082031 11.394531 110.550781 17.09375 166.015625 17.09375s110.933594-5.699219 166.015625-17.09375l28.628906-5.921875c35.558594-7.347656 61.355469-39.03125 61.355469-75.339844v-229.929688c0-36.308593-25.804688-67.984374-61.355469-75.339843zm-88.363281 208.007812-152.0625 89.855469c-3.269531 1.929688-6.859375 2.890625-10.460938 2.890625-3.5 0-6.988281-.902344-10.191406-2.730469-6.492187-3.710937-10.375-10.382812-10.375-17.867187v-179.703125c0-7.484375 3.882813-14.15625 10.375-17.867188 6.503906-3.707031 14.21875-3.644531 20.652344.167969l152.054688 89.839844c6.324218 3.738281 10.105468 10.359375 10.105468 17.707031s-3.773437 13.976562-10.097656 17.707031zm0 0"
      />
    </svg>
  </PlainLink>
);

export const Emblem = props => {
  const isMobile = useMediaQuery({
    query: `(max-device-width: ${breakpoint.md}px)`
  });
  return (
    <Icon
      {...props}
      alt={"emblem"}
      style={{
        margin: isMobile ? "3.25rem auto" : "6.25rem auto",
        height: isMobile ? "3.625rem" : undefined,
        ...(props.style || {})
      }}
    >
      {emblem}
    </Icon>
  );
};

const Centered = styled.span`
  margin: auto;
  display: flex;
  justify-content: center;
`;

export const CenteredEmblem = props => (
  <Centered>
    <Emblem {...props} />
  </Centered>
);

export default Icon;
